import React from "react";
import PropTypes from "prop-types";
import {getLocalStorageItem, setLocalStorageItem} from "../../../utilities/storageFunctions";
import {toggleArrayValue} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";

export default function PricingSection(props) {

  const {className, leftComponents, rightComponents, text, children, sectionId} = props;

  const parsedSavedOpenedJSON = sectionId ? getLocalStorageItem("pricingSectionsOpened") || [] : [];
  const [opened, setOpened] = React.useState(!parsedSavedOpenedJSON.includes(sectionId));

  const openedChange = () => {
    setOpened(!opened);
    const parsedSavedOpenedJSONUpdated = sectionId ? getLocalStorageItem("pricingSectionsOpened") || [] : [];
    setLocalStorageItem("pricingSectionsOpened", JSON.stringify(
      toggleArrayValue(parsedSavedOpenedJSONUpdated, sectionId)
    ))
  }

  return (
    <section className={"pr-section flex flex--column " + (opened ? "pr-section--opened mb-2 " : "") + (className || "")}>
      <div className="pr-bar flex flex--center flex--between pl-075 pr-075 pt-05 pb-05 border-box mb-1">
        <div className="flex flex--center">
          <span className={"link bold pr-sort-link" + (opened ? " pr-sort-link--active" : "")}
                onClick={openedChange}>
            {text}
          </span>
          {leftComponents || null}
        </div>
        <div className="flex flex--center">
          {rightComponents || null}
        </div>
      </div>
      <div className="pr-section__content flex-item">{children}</div>
    </section>
  )
}

PricingSection.propTypes = {
  className: PropTypes.string,
  leftComponents: PropTypes.any,
  rightComponents: PropTypes.any,
  text: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
}
